import styled from "styled-components";

export const StyledFooter = styled.footer`
  min-height: 50px;
  background-color: #121619;
  color: white;
  border-top: 1px solid #7e927f;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 10px;
  font-size: 14px;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: center;
  gap: 20px 20px;

  a {
    text-decoration: none;
    color: white;
    cursor: pointer;
  }
`;

export const StyledFooterSection = styled.div`
  width: 200px;
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 5px;
`;

export const StyledSocialMedia = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
`;
